// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2qdGI","rootSuccess":"CompleteLink_rootSuccess__3sU3W","rootFailure":"CompleteLink_rootFailure__-diTd","isDisabled":"CompleteLink_isDisabled__3mF5J"};